import "@phpgt/flux";

import("./ui/autosave-feedback.es6");
import("./ui/theme-toggle.es6");
import("./ui/hex-twinkle.es6");
import("./component/global-header.es6");
import("./component/dashboard-chart.es6");
import("./page/digital-style.es6");
